// ** Custom Components
import { PortableText } from "@portabletext/react"
import { classNames, columnSpan } from "../../utils/helpers"
import Box from "../Box"
import Container from "../Container"
import SectionColumn from "../SectionColumn"
import { serializers } from "../Serializers"
import Text from "../Text"
import { GatsbyImage } from "gatsby-plugin-image"

const SectionColumnText = ({ section }: any) => {
  const { listItems, tags } = section
  const isSimpleColumn =
    tags.includes("section-simple-column") ||
    tags.includes("section-column-text")
  const span = columnSpan(tags)

  return (
    <Box className={classNames(isSimpleColumn && "bg-gray-50 py-4 lg:py-12")}>
      <Container
        className={classNames(
          isSimpleColumn
            ? "relative pb-0"
            : "flex flex-col w-full gap-10 mt-10 md:mt-14"
        )}
        fullWidthOnMobile={false}
        constrainedToBreakPoint
      >
        <SectionColumn className={classNames(isSimpleColumn && "my-8 lg:mt-8")}>
          {listItems[0] && !isSimpleColumn ? (
            <Box
              className={classNames(
                span === "equal"
                  ? "lg:basis-1/2"
                  : span === "wider-left"
                  ? "lg:flex-1"
                  : ""
              )}
            >
              <PortableText
                components={serializers}
                value={listItems[0]._rawContent}
              />
            </Box>
          ) : listItems[0] && isSimpleColumn ? (
            <Box className="w-full lg:w-1/2 text-center">
              <GatsbyImage
                className="w-24 h-24 lg:w-32 lg:h-32 m-8 mb-2"
                objectFit="contain"
                image={listItems[0]?.Image?.asset?.gatsbyImageData}
                alt={listItems[0]?.Image?.asset?.altText || "section step"}
              />
              <Text variant="large" className="text-blue-500 font-bold">
                {listItems[0].title}
              </Text>
              <Text variant="body-copy" className="px-16 lg:mt-8">
                {listItems[0].value}
              </Text>
            </Box>
          ) : null}
          {listItems[1] && !isSimpleColumn ? (
            <Box
              className={classNames(
                span === "equal"
                  ? "lg:basis-1/2"
                  : span === "wider-left"
                  ? "lg:basis-8/12"
                  : ""
              )}
            >
              <PortableText
                components={serializers}
                value={listItems[1]._rawContent}
              />
            </Box>
          ) : listItems[1] && isSimpleColumn ? (
            <Box className="w-full lg:w-1/2 text-center">
              <GatsbyImage
                className="w-24 h-24 lg:w-32 lg:h-32 m-8 mb-2"
                objectFit="contain"
                image={listItems[1]?.Image?.asset?.gatsbyImageData}
                alt={listItems[1]?.Image?.asset?.altText || "section step"}
              />
              <Text variant="large" className="text-blue-500 font-bold">
                {listItems[1].title}
              </Text>
              <Text variant="body-copy" className="mt-4 lg:mt-8 px-16 ">
                {listItems[1].value}
              </Text>
            </Box>
          ) : null}
          {listItems[2] && !isSimpleColumn ? (
            <Box
              className={classNames(
                span === "equal"
                  ? "lg:basis-1/2"
                  : span === "wider-left"
                  ? "lg:basis-8/12"
                  : ""
              )}
            >
              <PortableText
                components={serializers}
                value={listItems[1]._rawContent}
              />
            </Box>
          ) : listItems[2] && isSimpleColumn ? (
            <Box className="w-full lg:w-1/2 text-center">
              <GatsbyImage
                className="w-24 h-24 lg:w-32 lg:h-32 m-8 mb-2"
                objectFit="contain"
                image={listItems[2]?.Image?.asset?.gatsbyImageData}
                alt={listItems[2]?.Image?.asset?.altText || "section step"}
              />
              <Text variant="large" className="text-blue-500 font-bold">
                {listItems[2].title}
              </Text>
              <Text variant="body-copy" className="mt-4 lg:mt-8 px-16 ">
                {listItems[2].value}
              </Text>
            </Box>
          ) : null}
        </SectionColumn>
      </Container>
    </Box>
  )
}

export default SectionColumnText
